import classic from 'ember-classic-decorator';

import ApplicationSerializer from './application';

@classic
export default class MediaKitSerializer extends ApplicationSerializer {
  attrs = {
    mediaKitImages: {
      key: 'media_kit_images',
      embedded: 'always',
      serialize: 'records'
    }
  };
}
